module.exports = __webpack_public_path__ + "img/WMT.eab6b7e7.png";